/**
 * Segmented Active / History tab control.
 * mode: "active" | "history"
 */
export function FilterTabs({ mode, onChange, labels = { active: "Active", history: "History" } }) {
  return (
    <div className="flex gap-0.5 p-1 bg-slate-100 rounded-xl" role="tablist">
      {["active", "history"].map(m => (
        <button
          key={m}
          role="tab"
          aria-selected={mode === m}
          data-testid={`filter-tab-${m}`}
          onClick={() => onChange(m)}
          className={`px-4 py-1.5 text-sm font-semibold rounded-lg transition-all ${
            mode === m
              ? "bg-white shadow text-slate-900"
              : "text-slate-500 hover:text-slate-700"
          }`}>
          {labels[m]}
        </button>
      ))}
    </div>
  );
}
